const isTouchEnabled = () => {
  if (typeof window !== 'undefined') {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.maxTouchPoints > 0
    )
  }
  return null
}

const isWebkitBased = () => {
  if (typeof window === 'undefined' || !window.navigator?.userAgent)
    return false

  return (
    navigator.userAgent.includes('Macintosh') ||
    navigator.userAgent.includes('iPhone') ||
    navigator.userAgent.includes('iPad')
  )
}

export const isMobileiOS = () => {
  if (typeof window === 'undefined' || !window.navigator?.userAgent)
    return false

  return (
    navigator.userAgent.includes('iPhone') ||
    navigator.userAgent.includes('iPad') ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
}

export default {
  isTouchEnabled,
  isWebkitBased,
  isMobileiOS,
}
